import { EventsTypeEnum } from '__generated__/types';
import { TFunction } from 'i18next';

export const LABELS_MAP = {
  [EventsTypeEnum.PublicHolidayEvent]: (t: TFunction) => t('calendar.publicHolidays'),
  [EventsTypeEnum.ProductionEvent]: (t: TFunction) => t('calendar.productionHolidays'),
  [EventsTypeEnum.PoLeadtimeEvent]: (t: TFunction) => t('calendar.poLeadtime'),
};
